let applicationName = "";
const setApplicationName = (name) => {
  applicationName = name;
};
export {
  applicationName,
  setApplicationName
};
